var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.5V12H18v7.5h1.5v-3h2.25V15H19.5v-1.5h3zM14.25 19.5h-3V12h3a2.252 2.252 0 012.25 2.25v3a2.253 2.253 0 01-2.25 2.25zm-1.5-1.5h1.5a.751.751 0 00.75-.75v-3a.75.75 0 00-.75-.75h-1.5V18zM8.25 12H4.5v7.5H6v-2.25h2.25a1.502 1.502 0 001.5-1.5V13.5a1.502 1.502 0 00-1.5-1.5zM6 15.75V13.5h2.25v2.25H6z",
    fill: "#45464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5v-3a.68.68 0 00-.225-.525l-5.25-5.25A.682.682 0 0010.5 1.5H3A1.504 1.504 0 001.5 3v18A1.5 1.5 0 003 22.5h12V21H3V3h6v4.5A1.504 1.504 0 0010.5 9H15v1.5h1.5zm-6-3V3.3l4.2 4.2h-4.2z",
    fill: "#45464F"
  })));
}
export default SvgDocumentPdf;